import React  from 'react'
import { graphql } from 'gatsby'

import PageHeader from '../components/PageHeader'
import Content from '../components/Content.js'
import Layout from '../components/Layout.js'
// import Accordion from '../components/Accordion'
import BackgroundVideo from '../components/BackgroundVideo'
// import Gallery from '../components/Gallery'
// import Popup from '../components/Popup'

// Export Template for use in CMS preview
export const ComponentsPageTemplate = ({
  title,
  subtitle,
  featuredImage,
  section1,
  section2,
  subsection2,
  section3,
  subsection3,
  section4,
  subsection4,
  // section5,
  // subsection5,
  video,
  videoPoster,
  videoTitle,
  // accordion,
  // body,
  // gallery
}) => (
  <main>
    <PageHeader
      title={title}
      subtitle={subtitle}
      backgroundImage={featuredImage}
    />
{/* 
    <section className="section">
      <div className="container">
        <h2>SKILL</h2>
        <Gallery images={gallery} />
      </div>
    </section> */}


    <section className="section">
      <div className="container">
        <Content source={section1} />
      </div>
    </section>



    <section className="BackgroundVideo-section section">
      <BackgroundVideo poster={videoPoster} videoTitle={videoTitle}>
        {video && <source src={video} type="video/mp4" />}
      </BackgroundVideo>
    </section>


    <section className="section">
      <div className="container">
        <Content source={section2} />
        <details style={{ 'background-color':'aliceblue', 'padding':'1em'}}><summary>OPEN</summary>
          <p style={{'padding-top':'0.5em'}} >
            <Content source={subsection2} />
          </p>
        </details>
      </div>
    </section>


    <section className="section">
      <div className="container">
        <Content source={section3} />
        <details style={{ 'background-color':'aliceblue', 'padding':'1em'}}><summary>OPEN</summary>
          <p style={{'padding-top':'0.5em'}} >
            <Content source={subsection3} />
          </p>
        </details>
      </div>
    </section>
    <section className="section">
      <div className="container">
        <Content source={section4} />
        <details style={{ 'background-color':'aliceblue', 'padding':'1em'}}><summary>OPEN</summary>
          <p style={{'padding-top':'0.5em'}} >
            <Content source={subsection4} />
          </p>
        </details>
      </div>
    </section>

{/* 
    <section className="section">
      <div className="container">
        <Content source={section5} />
        <details style={{ 'background-color':'aliceblue', 'padding':'1em'}}><summary>OPEN</summary>
          <p style={{'padding-top':'0.5em'}} >
            <Content source={subsection5} />
          </p>
        </details>
      </div>
    </section> */}

    {/* <section className="BackgroundVideo-section section">
      <BackgroundVideo poster={videoPoster} videoTitle={videoTitle}>
        {video && <source src={video} type="video/mp4" />}
      </BackgroundVideo>
    </section> */}

    {/* <section className="section">
      <div className="container">
        <Accordion items={accordion} />
      </div>
    </section> */}

  </main>
)

const ComponentsPage = ({ data: { page } }) => (
  <Layout
    meta={page.frontmatter.meta || false}
    title={page.frontmatter.title || false}
  >
    <ComponentsPageTemplate {...page} {...page.frontmatter} body={page.html} />
  </Layout>
)

export default ComponentsPage

export const pageQuery = graphql`
  query ComponentsPage($id: String!) {
    page: markdownRemark(id: { eq: $id }) {
      ...Meta
      ...Gallery
      html
      frontmatter {
        title
        template
        subtitle
        featuredImage
        section1
        section2
        subsection2
        section3
        subsection3
        section4
        subsection4
        video
        videoPoster
        videoTitle
      }
    }
  }
`
